import { $t } from '@/i18n'
export const getHashQueryParams = () => {
  const hashSearch = window.location.hash.split('?')?.[1]
  const searchParams = new URLSearchParams(hashSearch)
  return Object.fromEntries(searchParams.entries())
}

export const mobileCheck = {
  isMobile: /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent,
  ),
  isIOS: /iPhone|iPad|iPod/i.test(navigator.userAgent),
}

/**
 * 密码强度校验工具
 * @param {string} password 待校验的密码
 * @param {string} username 关联的用户名（用于规则2校验）
 * @returns { isValid: boolean, message: string } 校验结果和错误信息（只返回第一个错误）
 */
export function validatePasswordStrength(password, username = '') {
  // 规则1：至少8位且包含三类字符
  if (password.length < 8) {
    return {
      isValid: false,
      message: $t('hf_web_validate_password_tip_1_msg'),
    }
  }

  const hasNumber = /[0-9]/.test(password)
  const hasLower = /[a-z]/.test(password)
  const hasUpper = /[A-Z]/.test(password)
  const hasSpecial = /[^a-zA-Z0-9]/.test(password)

  const charTypesCount = [hasNumber, hasLower, hasUpper, hasSpecial].filter(Boolean).length
  if (charTypesCount < 3) {
    return {
      isValid: false,
      message: $t('hf_web_validate_password_tip_1_msg'),
    }
  }

  // 规则2：不能包含用户名及其变体
  const forbiddenTexts = [
    username.toLowerCase(),
    username.split('').reverse().join('').toLowerCase(),
    '123',
    'admin',
  ].filter((v) => v.length > 0)

  if (forbiddenTexts.some((text) => password.toLowerCase().includes(text))) {
    return {
      isValid: false,
      message: $t('hf_web_validate_password_tip_2_msg'),
    }
  }

  // 规则3：不能有连续4位及以上递增/递减数字
  const hasSequentialNumbers = () => {
    const digits = password.replace(/[^0-9]/g, '')
    if (digits.length < 4) return false

    for (let i = 0; i <= digits.length - 4; i++) {
      const quad = digits.slice(i, i + 4)
      const isIncreasing =
        quad === '0123' ||
        quad
          .split('')
          .every((c, j, arr) => j === 0 || c.charCodeAt(0) - arr[j - 1].charCodeAt(0) === 1)
      const isDecreasing =
        quad === '3210' ||
        quad
          .split('')
          .every((c, j, arr) => j === 0 || arr[j - 1].charCodeAt(0) - c.charCodeAt(0) === 1)

      if (isIncreasing || isDecreasing) return true
    }
    return false
  }

  if (hasSequentialNumbers()) {
    return {
      isValid: false,
      message: $t('hf_web_validate_password_tip_3_msg'),
    }
  }

  // 规则4：不能有连续4位及以上相同字符
  if (/(.)\1{3,}/.test(password)) {
    return {
      isValid: false,
      message: $t('hf_web_validate_password_tip_4_msg'),
    }
  }

  return {
    isValid: true,
    message: '',
  }
}

